<template>
    <v-card>
        <v-card-title>
      <v-icon
              :class="iconClass"
              :size="iconSize"
      >
        {{icon}}
      </v-icon>
      <v-layout
        column
        align-start
      >
        <div class="caption text-uppercase">
            {{title}}
        </div>
        <div>
            <transition
                        enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut"
                        mode="out-in"
                        appear
            >
                <span
                        :key="value"
                        :class="['display-2 font-weight-black',isDark ? 'number-color-dark' : 'number-color']"
            v-text="cleanedValue || '—'"
          ></span>
            </transition>
          <strong v-if="value">{{unit}}</strong>

        </div>

      </v-layout>
        <v-spacer></v-spacer>
            <v-btn color="primary" fab small dark v-if="explanation" @click="dialog=true">
                <v-icon style="color: #FFFFFF !important;">fa-info</v-icon>
            </v-btn>
            <v-dialog  v-if="explanation" v-model="dialog" max-width="800">
                <v-card>
                    <v-card-title class="primary white--text heading">
                        {{title}}
                    </v-card-title>
                    <v-card-text>
                        <slot></slot>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-btn icon class="align-self-start" size="28" v-if="to" @click="jump">
                <v-icon>fa-arrow-right</v-icon>
            </v-btn>
        </v-card-title>
    </v-card>
</template>

<script>
  export default {
    name: 'ValueBox',
    props: {
      icon: {type: String, default: 'fa-heart'},
      title: {type: String, default: ''},
      value: {type: Number, default: null},
      unit: {type: String, default: ''},
      iconSize: {type: String, default: '64'},
      iconClass: {type: String, default: 'mr-5'},
      useInt: {type: Boolean, default: false},
      explanation: {type: Boolean, default: false},
      to: {type: String, default: null}
    },
      data: () => ({
          dialog: false,

      }),
    computed: {
        isDark(){
            return process.env.VUE_APP_THEME=='dark'
        },
      cleanedValue () {
        if (this.value == null) {
          return this.value
        }
        if(this.useInt){
            return this.value.toFixed(0)
        }
        if (this.value > 1000) {
          return this.value.toFixed(0)
        } else if (this.value >100) {
        // for values less than 1000 return 2 decimal point
          return this.value.toFixed(1)
        }
        // for values less than 100 return 2 decimal point
        return this.value.toFixed(2)
      }
    },
    methods: {
      jump () {
        this.$router.replace(this.to)
      }
    }
  }
</script>

<style scoped>
.number-color{
    color: #555;
}
.number-color-dark{
    color: #FFFFFF;
}
</style>
